export default __webpack_public_path__ + "static/media/plus-mark.80169b22.png";